import { createFileRoute, Link } from '@tanstack/react-router';
import {
  IressStack,
  IressText,
  IressButton,
  IressPanel,
} from '@iress-oss/ids-components';

export const Route = createFileRoute('/$')({
  component: NotFoundPage,
});

/**
 * Catch-all route that renders the 404 page for any unmatched paths.
 */
function NotFoundPage() {
  return (
    <IressStack
      style={{ height: 'var(--app-height, 100dvh)' }}
      verticalAlign="middle"
    >
      <IressPanel
        mx="auto"
        my="xl"
        p="xl"
        textAlign="center"
        style={{ width: 'fit-content' }}
        alignSelf="center"
      >
        <IressText element="h1" textStyle="typography.heading.1">
          404
        </IressText>
        <IressText>Page not found</IressText>
        <IressButton mode="primary" element={Link} to="/" mt="spacing.4">
          Go back home
        </IressButton>
      </IressPanel>
    </IressStack>
  );
}
